var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Compañia")]),_c('v-card-text',[_c('reda-form',{attrs:{"value":_vm.getCompany,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }